import { LuBuilding, LuLayoutGrid, LuSearch, LuSlidersHorizontal, LuUsers } from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  tour('contacts', '/contacts', 'partner', [
    ['tabs', 'contacts.tabs', LuUsers],
    ['filters', 'contacts.filters', LuSlidersHorizontal],
    ['list', 'contacts.list', LuLayoutGrid, { placement: 'top', ...opt }],
  ]),
  // PartnerList is shared with CRM > Accounts, which reuses these targets.
  tour('contacts_accounts', '/contacts/accounts', 'partner', [
    ['search', 'contacts_accounts.search', LuSearch],
    ['list', 'contacts_accounts.list', LuBuilding, { placement: 'top' }],
  ], { exact: true }),
];

export default tours;
